var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("popups popups--" + _vm.state)},_vm._l((_vm.popups),function(popup,index){return _c("popup",_vm._b({key:index,tag:"component"},'component',popup,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }